module.exports = __webpack_public_path__ + "img/rotiv-artic-g_wXjMR2n8M-unsplash.f9e66254.jpg";